import {useContext} from "react";
import {CustomThemeContext} from "./CustomThemeProvider";
import {Button} from "@material-ui/core";

export default function ThemeSwitcher() {
    const { currentTheme, setTheme } = useContext(CustomThemeContext);

    function handleThemeChange() {
            if (currentTheme === 'normal')
            {
                setTheme('pastelCandy');
            }
            else {
            setTheme('normal');
            }
    }

    return (<>
            <Button onClick={handleThemeChange}>Switch Theme</Button>
        </>
    );
}